/**
 * Whether or not a `statusCode` is associated with failed request.
 */
export function isStatusCodeError(statusCode?: number): boolean {
    return !statusCode || statusCode >= 400;
}
